import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/main.css'; // Add this import for global styles
import App from './App';

import "./fonts/Playfair/PlayfairDisplay-Italic-VariableFont_wght.ttf";
import "./fonts/TTF/THICCCBOI-SemiBold.ttf";
import "./fonts/TTF/THICCCBOI-Bold.ttf";
import "./fonts/TTF/THICCCBOI-Medium.ttf";
import "./fonts/TTF/THICCCBOI-Thin.ttf";
import "./fonts/TTF/THICCCBOI-ExtraBold.ttf";

const root = ReactDOM.createRoot(document.getElementById('root'));
window.history.scrollRestoration = 'manual'
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

